export function taskActionResult(task, results = []) {
  if (task.cancelled) return task.raw?.cancelReason || task.cancelReason || "";
  const recorded = task.raw?.doneReason || task.doneReason;
  if (recorded) return recorded;
  if (!task.done) return "";
  const result = results.find(row =>
    row.taskId === task.id ||
    (["call", "follow"].includes(task.category) &&
      row.clientId === task.clientId && task.completedAt &&
      row.createdAt === task.completedAt),
  );
  return result ? [result.label, result.notes].filter(Boolean).join(" — ") : "";
}
